import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import 'd3';

if (environment.production) {
  enableProdMode();
  window.console.log = () => {}; // disable any console.log debugging statements in production mode
  // window.console.error = function () { };
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
